import PropTypes from "prop-types";
import { Paper } from "@mui/material";

const CHROME_VARIANT = Object.freeze({
  spread: "actionRowSpread",
  end: "actionRowEnd",
  cta: "actionRowCta",
});

export const ACTION_ROW_LAYOUT_SX = Object.freeze({
  spread: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
    gap: 2,
    mt: 3,
  },
  end: {
    display: "flex",
    justifyContent: { xs: "stretch", lg: "flex-end" },
    alignItems: "center",
    flexShrink: 0,
    gap: 2,
    pt: 2,
  },
  cta: {
    display: "flex",
    justifyContent: { xs: "center", md: "flex-end" },
    alignItems: "center",
    flexWrap: "wrap",
    flexShrink: 0,
    gap: 1.5,
  },
});

export const ACTION_ROW_CHROME = ACTION_ROW_LAYOUT_SX;

export const actionRowSpreadSx = ACTION_ROW_LAYOUT_SX.spread;

export default function ActionRow({ children, chrome = "spread", sx = null }) {
  return (
    <Paper variant={CHROME_VARIANT[chrome]} component="div" elevation={0} sx={sx}>
      {children}
    </Paper>
  );
}

ActionRow.propTypes = {
  children: PropTypes.node,
  chrome: PropTypes.oneOf(["spread", "end", "cta"]),
  sx: PropTypes.object,
};
